import { Arrange, Text } from '@loomhq/lens';
import React, { useMemo } from 'react';

import { getCloudfrontURI } from 'utilities/avatar';

import googleIconSrc from 'img/icons/google.svg';
import slackIconSrc from 'img/icons/slack.svg';

import UserAvatar from 'components/user-avatar';

const IMG_SRC = {
  google: googleIconSrc,
  slack: slackIconSrc,
};

const MentionSuggestion = ({ user }) => {
  const { avatar, source, display } = user;
  const userAvatarSrc = useMemo(() => {
    return avatar && getCloudfrontURI(avatar);
  }, [avatar]);

  return (
    <Arrange
      justifyContent="start"
      alignItems="center"
      gap="small"
      columns={['24px', '1fr', '24px']}
    >
      <UserAvatar avatarSrc={userAvatarSrc} name={display} avatarSize={3} />
      <Text size="medium" fontWeight="bold" color="white">
        {user.display}
      </Text>
      {source && <img src={IMG_SRC[source]} />}
    </Arrange>
  );
};

export default MentionSuggestion;
